export const stockConstants = {

    GET_STOCK_REQUEST: 'GET_STOCK_REQUEST',
    GET_STOCK_SUCCESS: 'GET_STOCK_SUCCESS',
    GET_STOCK_FAILURE: 'GET_STOCK_FAILURE',

    GET_EXCEL_STOCKS_REQUEST: 'GET_EXCEL_STOCKS_REQUEST',
    GET_EXCEL_STOCKS_SUCCESS: 'GET_EXCEL_STOCKS_SUCCESS',
    GET_EXCEL_STOCKS_FAILURE: 'GET_EXCEL_STOCKS_FAILURE',

    ADD_STOCK_REQUEST: 'ADD_STOCK_REQUEST',
    ADD_STOCK_SUCCESS: 'ADD_STOCK_SUCCESS',
    ADD_STOCK_FAILURE: 'ADD_STOCK_FAILURE',

    EDIT_STOCK_REQUEST: 'EDIT_STOCK_REQUEST',
    EDIT_STOCK_SUCCESS: 'EDIT_STOCK_SUCCESS',
    EDIT_STOCK_FAILURE: 'EDIT_STOCK_FAILURE'

};
